<template>
  <!-- w-32 h-31  -->
  <circle cx='10' cy='10' r='5.25' stroke='#1C498E' stroke-width='1.5' />
  <path d='M2 24V23.5C2 19.3579 5.35786 16 9.5 16V16C13.6421 16 17 19.3579 17 23.5V24' stroke='#1C498E'
        stroke-width='1.5'
        stroke-linecap='round' />
  <path d='M20 15.75H29.5' stroke='#1C498E' stroke-width='1.5' stroke-linecap='round' />
  <path d='M24.75 11L24.75 20.5' stroke='#1C498E' stroke-width='1.5' stroke-linecap='round' />
</template>
